export default __webpack_public_path__ + "static/media/seleccio.724c4f38.svg";